import React, { useState, useEffect } from 'react';
import AdminDashboard from './AdminDashboard';
import Swal from 'sweetalert2';
import '../../assets/css/admin/allcourses.css';
import axios from 'axios';

const PendingIntSchls = () => {
    const [internationalSchools, setInternationalSchools] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');

    useEffect(() => {
        fetchInternationalSchools();
    }, []);

    const fetchInternationalSchools = async () => {
        try {
            const response = await fetch('https://api.myskills.lk/internationalSchools/pending');
            const data = await response.json();
            setInternationalSchools(data);
        } catch (error) {
            console.error('Error fetching international schools:', error);
        }
    };

    const handleDelete = async (schoolId) => {
        Swal.fire({
            title: "Are you sure?",
            text: "Do you want to delete this international school?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, delete it!"
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    const response = await fetch(`https://api.myskills.lk/internationalSchools/delete/${schoolId}`, {
                        method: 'POST'
                    });
                    if (response.ok) {
                        // Update local state after successful deletion
                        const updatedSchools = internationalSchools.filter(school => school.id !== schoolId);
                        setInternationalSchools(updatedSchools);
                        
                        // Show success message
                        Swal.fire({
                            title: "Deleted!",
                            text: "The international school has been deleted.",
                            icon: "success"
                        });
                    } else {
                        console.error('Failed to delete international school');
                        Swal.fire({
                            title: "Error!",
                            text: "Failed to delete the international school.",
                            icon: "error"
                        });
                    }
                } catch (error) {
                    console.error('Error deleting international school:', error);
                    Swal.fire({
                        title: "Error!",
                        text: "Failed to delete the international school.",
                        icon: "error"
                    });
                }
            }
        });
    };

    const handleApprove = async (school) => {
        Swal.fire({
            title: "Are you sure?",
            text: "Do you want to approve this international school?",
            icon: "question",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, approve it!"
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    const response = await fetch(`https://api.myskills.lk/internationalSchools/approve/${school.id}`, {
                        method: 'POST'
                    });
                    if (response.ok) {
                        setInternationalSchools(internationalSchools.filter(s => s.id !== school.id));
                        
                        // Show success message
                        Swal.fire({
                            title: "Approved!",
                            text: "The international school has been approved.",
                            icon: "success"
                        });
                        
                        // Now send the approval email
                        sendEmail(school);
                    } else {
                        console.error('Failed to approve international school');
                        Swal.fire({
                            title: "Error!",
                            text: "Failed to approve the international school.",
                            icon: "error"
                        });
                    }
                } catch (error) {
                    console.error('Error approving international school:', error);
                    Swal.fire({
                        title: "Error!",
                        text: "Failed to approve the international school.",
                        icon: "error"
                    });
                }
            }
        });
    };

    const sendEmail = async (school) => {
        const emailData = {
            id: school.id,
            name: school.intschlName,
            email: school.commonEmail,
            subject: 'International School Approval Notification',
            message: `
                Dear ${school.intschlName} Team,
    
                We are pleased to inform you that your institute has been approved and added to our system.
    
                If you have any questions or need further clarification, please do not hesitate to contact the admin.
    
                Thank you,
                Education Management System
            `
        };
    
        try {
            await axios.post('https://api.myskills.lk/internationalSchools/send', emailData);
            Swal.fire({
                title: "Email Sent!",
                text: `Notified ${school.intschlName} via Email.`,
                icon: "success"
            });
        } catch (error) {
            console.error('Error sending email:', error);
            Swal.fire({
                title: "Email Sending Failed",
                text: `Could not send approval email to ${school.intschlName}.`,
                icon: "error"
            });
        }
    };

    // Filter international schools based on search term
    const filteredInternationalSchools = internationalSchools.filter(school => 
        (school.intschlName && school.intschlName.toLowerCase().includes(searchTerm.toLowerCase())) ||
        (school.commonEmail && school.commonEmail.toLowerCase().includes(searchTerm.toLowerCase())) ||
        (school.commonPhone && school.commonPhone.toLowerCase().includes(searchTerm.toLowerCase()))
    );

    const handleSearchSubmit = (e) => {
        e.preventDefault(); // Prevent form submission
    };
    

    return (
        <div>
            <AdminDashboard />
            <div className='AllViews-admin-course'>
                <div className="search-icon-admin admin-course-search">
                    <h1>PENDING INTERNATIONAL SCHOOLS</h1>
                    <form onSubmit={handleSearchSubmit}>
                        <input 
                            type="text" 
                            placeholder='Search Item' 
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                        />
                        <input type="submit" value="SEARCH" />
                    </form>
                </div>
                <div className="scroller-box">
                    <div className="table-course">
                        <table>
                            <thead>
                                <tr>
                                    <th>School Name</th>
                                    <th>Contact Person</th>
                                    <th>Email</th>
                                    <th>View</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                            {filteredInternationalSchools.map((school) => (
                                <tr key={school.id}>
                                    <td>{school.intschlName}</td>
                                    <td>{school.commonPhone}</td>
                                    <td>{school.commonEmail}</td>
                                    <td>
                                        <a href={school.instituteWebsite} target="_blank" rel="noopener noreferrer">
                                            Visit Website
                                        </a>
                                    </td>
                                    <td id='action-buttons'>
                                        <a href="#!" id='app-details' onClick={() => handleApprove(school)}>APPROVE</a>
                                        <a href="#!" id='del-details' onClick={() => handleDelete(school.id)}>DELETE</a>
                                    </td>
                                </tr>
                            ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default PendingIntSchls;
